/* NavToggle styles */
.navToggle {
  position: absolute;
  bottom: 15px;
  right: 9px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  border-color: light-dark(var(--brand-blue-100), var(--brand-grey-400));
  border-radius: 3px;
  background: transparent;
  transition: right var(--secondary-nav-transition-duration) var(--secondary-nav-transition-easing);
}

.navToggle:hover {
  border-color: light-dark(white, var(--brand-blue-400));
}

.navToggle:hover [data-name='ChevronIcon'] {
  color: light-dark(white, var(--brand-blue-300));
}

.navToggle [data-name='ChevronIcon'] {
  transition: transform var(--secondary-nav-transition-duration) var(--secondary-nav-transition-easing);
}

.expanded {
  right: 20px;
}
